import React from "react";

//UI Material
import { Card, Grid, Stack, Typography } from "@mui/material";

//Local components
import ElementCard from "../../ProComponents/ElementCard";

export default function QuoteClient({ data }) {
  return (
    <Card raised sx={{ height: "100%" }}>
      <Grid container sx={{ padding: 2 }} spacing={2}>
        <Grid item xs={12} align="left">
          <ElementCard
            ops={{
              title: "Información del cliente",
            }}
          />
        </Grid>
        <Grid item xs={6} align="left">
          <Stack>
            <Typography fontWeight="bold">Nombre</Typography>
            <Typography>{data.client.name}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} align="left">
          <Stack>
            <Typography fontWeight="bold">Identificación</Typography>
            <Typography>{data.client.id || "Sin asignar"}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} align="left">
          <Stack>
            <Typography fontWeight="bold">Correo electrónico</Typography>
            <Typography>{data.client.email || "Sin asignar"}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} align="left">
          <Stack>
            <Typography fontWeight="bold">Número de teléfono</Typography>
            <Typography>{data.client.phone || "Sin asignar"}</Typography>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
}
